import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function MySupportTickets() {
  const [tickets, setTickets] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/support/student/my-tickets").then(res => setTickets(res.data));
  }, []);

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <Header />

          <h2>🆘 My Support Tickets</h2>

          <table width="100%" border="1">
            <thead>
              <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map(t => (
                <tr key={t.id}>
                  <td>
                    <button onClick={() => nav(`/student/support/${t.id}`)}>
                      {t.title}
                    </button>
                  </td>
                  <td>{t.status}</td>
                  <td>{t.priority}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Header() {
  return (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};
const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};
const cardStyle = {
  maxWidth: 1000,
  margin: "auto",
  background: "#fff",
  borderRadius: 16,
  padding: 30,
};
